import { Form, Select, DatePicker, Button, Card, Row, Col, Divider } from "antd";
import moment from "antd/node_modules/moment";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { FilterBarType } from "./FilterBar";

export const RegionFilterBar = observer(({ store, children, actions, actionsSpan }: FilterBarType) => {
  const history = useHistory();

  const onSearch = () => store.onSearch(history);
  const onReset = () => store.filterStore.onReset(history);
  const onRefresh = () => store.refresh();

  const { showSearchBtn, showResetBtn, periodLabel } = store.filterStore;

  useEffect(() => {
    store.filterStore.loadRegions();
  }, []);

  
  return (
    <Card size="small" className="fm-filter-bar" bodyStyle={{ paddingBottom: 0 }}>
      <Form size="small" initialValues={store.filter}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item label="Region">
              <Select
                style={{ width: "100%" }}
                value={store.filter.regionId}
                onChange={(e) => store.filterStore.onRegion(e)}
              >
                <Select.Option value="">All</Select.Option>
                {store.filterStore.regions.map((x: any) => (
                  <Select.Option value={x.id} key={x.id}>
                    {x.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Division">
              <Select
                style={{ width: "100%" }}
                value={store.filter.divisionId}
                onChange={(e) => store.filterStore.onDivision(e)}
              >
                {store.filterStore.divisions.map((x: any) => (
                  <Select.Option value={x.id} key={x.id}>
                    {x.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Community">
              <Select
                style={{ width: "100%" }}
                value={store.filter.communityId}
                onChange={(e) => store.filterStore.onCommunity(e)}
              >
                {store.filterStore.communities.map((x: any) => (
                  <Select.Option value={x.id} key={x.id}>
                    {x.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {store.filterStore.showPeriod && (
            <Col span={8}>
              <Form.Item label={periodLabel}>
                <DatePicker.RangePicker
                  allowClear
                  style={{ width: "100%" }}
                  value={store.filter.period}
                  onChange={(e) => store.filterStore.onPeriod(e)}
                  ranges={{
                    Today: [moment(), moment()],
                    "This Week": [moment().startOf("week"), moment().endOf("week")],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "This Year": [moment().startOf("year"), moment().endOf("year")],
                  }}
                />
              </Form.Item>
            </Col>
          )}
          {children}

          {actionsSpan && (
            <Col span={actionsSpan} style={{ textAlign: "right" }}>
              {showSearchBtn && (
                <Button type="primary" ghost onClick={() => onSearch()}>
                  Search
                </Button>
              )}
              {showResetBtn && <Button onClick={() => onReset()}>Reset</Button>}
              <Button onClick={() => onRefresh()}>Refresh</Button>
              {actions && <Divider type="vertical" />}
              {actions}
            </Col>
          )}
        </Row>
        {!actionsSpan && (
          <Row>
            <Col span={24} style={{ textAlign: "right", paddingBottom: 12 }}>
              {showSearchBtn && (
                <Button type="primary" ghost onClick={() => onSearch()}>
                  Search
                </Button>
              )}
              {showResetBtn && <Button onClick={() => onReset()}>Reset</Button>}
              <Button onClick={() => onRefresh()}>Refresh</Button>
              {actions && <Divider type="vertical" />}
              {actions}
            </Col>
          </Row>
        )}
      </Form>
    </Card>
  );
});
